module.exports = __webpack_public_path__ + "img/arrow.0f284d94.svg";